import { render, staticRenderFns } from "./outboundOrderDetail.vue?vue&type=template&id=6aadb4ef&scoped=true&"
import script from "./outboundOrderDetail.vue?vue&type=script&lang=js&"
export * from "./outboundOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./outboundOrderDetail.vue?vue&type=style&index=0&id=6aadb4ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadb4ef",
  null
  
)

export default component.exports